import request from "@/axios/index";
// 登录
export function login(data) {
  return request({
    url: "/login",
    method: "post",
    data,
  });
}
// 退出登录
export function loginOut(data) {
  return request({
    url: "/logout",
    method: "post",
  });
}

// 注册
export function register(data) {
  return request({
    url: "/register",
    method: "post",
    data,
  });
}

// 验证码
export function vertify() {
  return request({
    url: "/captcha_image",
    method: "get"
  });
}

// 修改密码
export function changePassword(params) {
  return request({
    url: "/updatePassword",
    method: "put",
    params
  })
}

// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: "/info",
    method: "get",
    params
  });
}

// 注册账号
export function userRegister(data) {
  return request({
    url: "/sys/user/register",
    method: "post",
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
}

export function queryRegResult(id) {
  return request({
    url: "/sys/user/queryRegResult?queryKey=" + id,
    method: "get",
  });
}

export function approveUser(params) {
  return request({
    url: "/sys/user/approveUser",
    method: "get",
    params
  });
}

// 模版附件列表
export function attachmentTemplateList() {
  return request({
    url: "/common/association/attachmentTemplateList",
    method: "get"
  });
}
// 业务类型列表
export function businessTypeItemList() {
  return request({
    url: "/dataDic/businessTypeItemList",
    method: "get"
  });
}

// 会员类型
export function memberTypeList() {
  return request({
    url: "/dataDic/memberTypeItemList",
    method: "get"
  });
}

// 行业动态
export function listBusinessAnnouncement(params) {
  return request({
    url: "/businessAnnouncement/list",
    method: "get",
    params
  });
}
// 行业动态详情
export function getByIdBusinessAnnouncement(id) {
  return request({
    url: "/businessAnnouncement/getById?id=" + id,
    method: "get",
  });
}
// 行业动态保存
export function saveBusinessAnnouncement(data) {
  return request({
    url: "/businessAnnouncement/save",
    method: "post",
    data
  });
}
// 行业动态修改
export function updateBusinessAnnouncement(data) {
  return request({
    url: "/businessAnnouncement/update",
    method: "post",
    data
  });
}
export function deleteBusinessAnnouncement(id) {
  return request({
    url: "/businessAnnouncement/delete?id=" + id,
    method: "post",
  });
}




